/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, styled } from "@mui/material";

export const StatusContainer = styled(Box)(({ status }) => ({
  height: "24px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor:
    status === "active" ? "rgba(52, 199, 89, 0.1)" : "rgba(211, 47, 47, 0.1)",
  color: status === "active" ? "#2E7D32" : "#D32F2F",
}));
